import {
  Card,
  CardHeader,
  CardBody,
  Row,
  Col,
  Label,
  Input,
  FormGroup,
} from 'reactstrap';

import { useTranslation } from 'react-i18next';

import { PromoFormValues } from 'types/promotion/promotionTypes';
import { FormikProps } from 'formik';
import styles from 'pages/Promotions/styles/promo.module.css';
import { ActiveStatusOptions } from 'pages/Promotions/PromoConstant';

const PromoActivation = ({
  formik,
}: {
  formik: FormikProps<PromoFormValues>;
}) => {
  const { t } = useTranslation();

  return (
    <Card>
      <CardHeader>
        <h5 className="card-title mb-0">{t('Activation')}</h5>
      </CardHeader>
      <CardBody className={`${styles['card-body-pd']}`}>
        <Row>
          <Col lg={6}>
            <div className="mb-3 row">
              <Label className="col-sm-3 col-form-label"></Label>
              <Col sm={9}>
                <div className="mt-2">
                  <FormGroup key={5}>
                    {ActiveStatusOptions(t).map(
                      (p: { label: string; value: string }, _index) => (
                        <div
                          key={p.value}
                          className="form-check form-check-inline"
                        >
                          <Input
                            className="form-check-input"
                            type="radio"
                            name="isActive"
                            id={p.label}
                            value={p.value}
                            checked={formik.values.isActive === p.value}
                            onChange={(e) => {
                              formik.handleChange(e);
                            }}
                          />
                          <Label className="form-check-label" htmlFor={p.label}>
                            {p.label}
                          </Label>
                        </div>
                      )
                    )}
                  </FormGroup>
                </div>
              </Col>
            </div>
          </Col>

          <Col lg={6}></Col>
        </Row>
      </CardBody>
    </Card>
  );
};
export default PromoActivation;
